import {
    SET_DATA_REFRESH_TIME,
    SET_MAP_REFRESH_RATE,
} from "../constants";
import { SettingsState } from '../interfaces/states';
import { SettingActions } from '../interfaces/actions'; // Use the interface instead
import configs from "../configs";

// Helper function to get map refresh rate from localStorage
const getStoredMapRefreshRate = (): string => {
    try {
        return localStorage.getItem('mapRefreshRate') || '30 secs';
    } catch (error) {
        console.warn('Failed to read mapRefreshRate from localStorage:', error);
        return '30 secs';
    }
};

// Helper function to save map refresh rate to localStorage
const saveMapRefreshRate = (refreshRate: string): void => {
    try {
        localStorage.setItem('mapRefreshRate', refreshRate);
    } catch (error) {
        console.warn('Failed to save mapRefreshRate to localStorage:', error);
    }
};

export const initialState: SettingsState = {
    dashboardRefresh: (configs.dashbordRefreshRate * (1000 * 60)), // 5 seconds is default
    mapRefreshRate: getStoredMapRefreshRate(), // Load from localStorage with fallback
};

export default (state = initialState, action: SettingActions): SettingsState => {
    switch (action.type) {
        case SET_DATA_REFRESH_TIME: {
            return { 
                ...state, 
                dashboardRefresh: (action.dashboardRefresh * 1000 * 60) 
            };
        }
        case SET_MAP_REFRESH_RATE: {
            // Save to localStorage whenever it changes
            saveMapRefreshRate(action.mapRefreshRate);
            return { 
                ...state, 
                mapRefreshRate: action.mapRefreshRate 
            };
        }
        default: {
            return state;
        }
    }
};